import z from 'zod'

export const contactUsFormchema = z.object({
  firstName: z.string().min(1, { message: 'First name is required' }),
  lastName: z.string().min(1, { message: 'Last name is required' }),
  email: z
    .string()
    .min(1, { message: 'Email is required' })
    .regex(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, { message: 'Invalid email address' }),
  subject: z.string().min(1, { message: 'Subject is required' }),
  content: z.string().min(1, { message: 'Content is required' }),
})

export type ContactUsFormSchema = z.infer<typeof contactUsFormchema>

export const demoFormSchema = z.object({
  name: z.string().min(1, { message: 'Name is required' }),
  email: z
    .string()
    .min(1, { message: 'Email is required' })
    .regex(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, { message: 'Invalid email address' }),
  howManyScreens: z.enum(['1-10', '10-20', '20-50', '50-100', '100+']),
})

export type DemoFormSchema = z.infer<typeof demoFormSchema>
